<template>
  <div>
    <div class="fullscreen-modal__content">
      <page>
        <page-title v-t="'c.mailingOverlay.stepTitle.title'"/>

        <form-wrap>
          <form-field-set :should-show-border="false">
            <text-input
              v-model="subject"
              direction="vertical"
              label="Subject"
              name="subject"
            />

            <text-area-input
              v-model="introText"
              direction="vertical"
              label="Intro"
              name="intro"
            />

          </form-field-set>
        </form-wrap>

      </page>
    </div>
    <div class="fullscreen-modal__footer">
      <div class="container">
        <div class="row">
          <div class="col-xs-6 col-lg-4 push-lg-2">
            <button-input
              v-t="'c.mailingOverlay.stepTitle.btnNext'"
              :is-disabled="isInvalid"
              @click="submit"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import isBlank from 'is-blank'
import FormMixin from '@/mixins/forms/Form'
import PageMixin from '@/mixins/pages/Page'
import NotificationsMixin from '@/mixins/notifications/notifications'

export default {
  mixins: [FormMixin, PageMixin, NotificationsMixin],
  computed: {
    ...mapState ({
      mailingId: state => state.mailing.entry.mailingId,
    }),
    isInvalid () {
      return isBlank(this.subject)
    },
    subject: {
      get () { return this.$store.state.mailing.entry.subject },
      set (value) { this.$store.dispatch('mailing/entry/setSubject', value) }
    },
    introText: {
      get () { return this.$store.state.mailing.entry.introText },
      set (value) { this.$store.dispatch('mailing/entry/setIntroText', value) }
    }
  },
  methods: {
    ...mapActions({
      createMailing: 'mailing/entry/createMailing',
      saveMailing: 'mailing/entry/saveMailing',
      nextStep: 'mailing/step/next',
    }),
    submit () {
      const request = isBlank(this.mailingId)
        ? this.createMailing()
        : this.saveMailing()

      request.then(() => {
        this.nextStep()
      })
    }
  }
}
</script>

<style lang="sass">
@import "~styles/imports"

.stats
  display: flex
  flex-direction: row
  justify-content: space-between
  align-items: center
  margin-bottom: rem-calc(30)
  margin-left: -10px;
  margin-right: -10px;

  &__item
    flex: 1;
    +font-size(48, 56)
    font-weight: 700
    background: #f0f3f5
    text-align: center
    padding: rem-calc(40 0)
    margin: rem-calc(10)

    span
      +font-size(14, 20)
      display: block
      color: #878c96
      font-weight: 400
</style>



// WEBPACK FOOTER //
// src/components/mailings/steps/Title.vue